const { axios, API_URL, generateHeaders, queryParamsToPathParams, loopPagenationResults } = require('./helper');

/**
 * @description returns all clients in javelina
 */
const getAllClients = async () => {
    const response = await axios.get(`${API_URL}pureProxy/core/searchClients/all`, {
        headers: generateHeaders()
    });
    if (response.status !== 200) {
        return null;
    }
    
    let results = {
        ...response.data,
        Response: {
            Client: await loopPagenationResults("Client", response.data),
        }
    };
    return results;
}

/**
 * @description returns all clients for a block of business
 * @param {String} blockOfBusinessId block of business id in JV
 */
const getAllClientsForBlockOfBusiness = async (blockOfBusinessId) => {
    const params = {
        blkOfBusID: blockOfBusinessId
    }
    let url = queryParamsToPathParams(params, `${API_URL}pureProxy/core/searchClients`);
    const response = await axios.get(url, {
        headers: generateHeaders()
    });
    if (response.status !== 200) {
        return null;
    }
   
    let results = {
        ...response.data,
        Response: {
            Client: await loopPagenationResults("Client", response.data),
        }
    };
    return results;
}

/**
 * @description returns a client by id and blk of bus
 * @param {String} blockOfBusinessId block of business id in JV
 * @param {String} clientId client id in JV
 */
 const getClient = async (blockOfBusinessId, clientId) => {
    const params = {
        blkOfBusID: blockOfBusinessId,
        clientId: clientId
    }
    let url = queryParamsToPathParams(params, `${API_URL}pureProxy/core/clients`);
    const response = await axios.get(url, {
        headers: generateHeaders()
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

module.exports = {
    getAllClients,
    getAllClientsForBlockOfBusiness,
    getClient
}